<template src="./basic-question.html"></template>

<script lang="ts">
import formatName from 'filters/format-name'

export default {
  props: {
    question: Object
  },
  methods: {
    formatUserName(user) {
      return formatName(user)
    }
  }
}
</script>
